export default function(nga, admin) {
    let entity = admin.getEntity('licence')
        .updateMethod('patch')
        .label('Licences');

    let pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('licence').label('LICENCE').isDetailLink(true).detailLinkRoute('show'),
            nga.field('user').label('USER').map(function (value, entry) {
                return entry['user.name'] + ' ' + (entry['user.surname'] || '');
            }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'),
            nga.field('purchase.order').label('ORDER').isDetailLink(true)
                .template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'),
            nga.field('type.name').label('TYPE').isDetailLink(true)
                .template('<entity-edit type="\'licencetype\'" id="entry.values[\'type.id\']" text="value"></entity-edit>'),
            nga.field('finalized', 'date').label('FINALIZED').format('yyyy-MM-dd'),
            nga.field('identifier').label('IDENTIFIER'),
            nga.field('ip').label('IP'),
            nga.field('promo', 'boolean').label('PROMO'),
        ])
        .sortDir('ASC')
        .url('licences');

    entity.showView().fields(
        nga.field('id').label('ID'),
        nga.field('licence').label('LICENCE'),
        nga.field('user').label('USER').map(function (value, entry) {
            return entry['user.name'] + ' ' + (entry['user.surname'] || '');
        }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'),
        nga.field('order').label('ORDER').isDetailLink(true).detailLinkRoute('show').map(function (value, entry) {
            if(!entry['purchase.created']) return null;

            let date = ParseDate(entry['purchase.created']);
            return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['purchase.id'], 4);
        }).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'),
        nga.field('manual_invoice').label('MANUAL_INVOICE'),
        nga.field('type').label('TYPE').isDetailLink(true).detailLinkRoute('show').map(function (value, entry) {
            return entry['type.name'];
        }).template('<entity-edit type="\'licencetype\'" id="entry.values[\'type.id\']" text="value"></entity-edit>'),
        nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'),
        nga.field('updated', 'date').label('UPDATED').format('yyyy-MM-dd'),
        nga.field('finalized', 'date').label('FINALIZED').format('yyyy-MM-dd'),
        nga.field('identifier').label('IDENTIFIER'),
        nga.field('promo', 'boolean').label('PROMO'),
        nga.field('gamesvr', 'referenced_list')
            .label('LICENCES_GAME_VR')
            .targetEntity(nga.entity('gamevrlicence').url('gamevr/licences'))
            .targetReferenceField('licence')
            .targetFields([
                nga.field('id').label('ID'),
                nga.field('gamevr').label('GAMEVR').map(function (value, entry) {
                    return entry['gamevr.name'];
                }).template('<entity-show type="\'gamevr\'" id="entry.values[\'gamevr.id\']" text="value"></entity-show>'),
                nga.field('order').label('ORDER').isDetailLink(true).map(function (value, entry) {
                    if(!entry['purchase.created']) return null;

                    let date = ParseDate(entry['purchase.created']);
                    return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['purchase.id'], 4);
                }).template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'),
                nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'),
            ])
    );

    entity.creationView().fields(
        nga.field('licence'),
        nga.field('user', 'reference')
            .map(function(value, entry) {
                return entry['user.id'];
            })
            .targetEntity(nga.entity('professional').url('professionals'))
            .targetField(nga.field('name').map(function (value, entry) {
                return entry['name'] + ' ' + (entry['surname'] || '');
            }))
            .perPage(0),
        nga.field('purchase', 'reference')
            .map(function(value, entry) {
                return entry['purchase.id'];
            })
            .targetEntity(nga.entity('purchase').url('purchases'))
            .targetField(nga.field('order').map(function (value, entry) {

                let date = ParseDate(entry['created']);

                if(date)
                    return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['id'], 4);
            }))
            .perPage(0),
        nga.field('manual_invoice').label('MANUAL_INVOICE'),
        nga.field('type', 'reference')
            .map(function(value, entry) {
                return entry['type.id'];
            })
            .targetEntity(nga.entity('licencetype').url('licencetypes'))
            .targetField(nga.field('name'))
            .perPage(0),
        nga.field('promo', 'boolean').label('PROMO')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>'),
        nga.field('finalized', 'date').format('yyyy-MM-dd').map(ParseDate),
        nga.field('identifier'),
        nga.field('ip'),
    ).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function(error, form, progression, notification, $filter) {

        $(':input').each(function(){
            $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
        });

        error.data.fields.forEach(function(error, index){
            let input = $('[name='+error.property_path+']');
            $('<span class="help-block error">'+error.message+'</span>').insertAfter(input);
            input.closest('.form-field').addClass('has-error');
        });

        progression.done();

        notification.log($filter('translate')(`INVALID_DETAILS_IN_FORM`), { addnCls: 'humane-flatty-error' });

        return true;
    }]);

    entity.editionView().fields(
        entity.creationView().fields()
    ).onSubmitError(entity.creationView().onSubmitError());

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/licence/config.js
 **/